import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './CivitasPage.css'

import siteImages from './images/site';
import { HEADER_LOGO_SIZES } from './images/site-sizes.mjs';
import qrImage from './images/LongevityQrCode.png';

const civitasLogo = siteImages['civitas-icon'];

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>×</button>
                {children}
            </div>
        </div>
    );
};

const CivitasPrivacyPage = () => {
    const navigate = useNavigate();

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isQRModalOpen, setIsQRModalOpen] = useState(false);

    useEffect(() => {
        document.documentElement.classList.add('dark-page');
        return () => document.documentElement.classList.remove('dark-page');
    }, []);

    const handleBurgerClick = (e) => {
        setIsMenuOpen(e.target.checked);
    };

    return (
        <div className="container">
            <div className="glass-header">
                <div className="header-content">
                    <div className="logo-container">
                        <img
                            src={civitasLogo.src}
                            srcSet={civitasLogo.srcSet}
                            sizes={HEADER_LOGO_SIZES}
                            width={civitasLogo.width}
                            height={civitasLogo.height}
                            alt="Civitas Logo"
                            className="logo-image"
                            decoding="async"
                            onClick={() => window.scrollTo(0, 0)}
                        />
                    </div>

                    <div className="header-controls">
                        {/* <button
                            className="qr-button"
                            onClick={() => setIsQRModalOpen(true)}
                        >
                            <span>Download</span>
                        </button> */}

                        <label className="burger" htmlFor="burger">
                            <input
                                type="checkbox"
                                id="burger"
                                checked={isMenuOpen}
                                onChange={handleBurgerClick}
                            />
                            <span></span>
                            <span></span>
                            <span></span>
                        </label>
                    </div>

                    {isMenuOpen && (
                        <div className="dropdown-menu">
                            <div className="menu-item" onClick={() => navigate('/civitas')}>Home</div>
                            {/* <div
                                className="menu-item"
                                onClick={() => document.querySelector('.features-section').scrollIntoView({ behavior: 'smooth' })}
                            >
                                Features
                            </div> */}
                            {/* <div
                                className="menu-item"
                                onClick={() => window.open('https://taci.uk/civitas', '_blank')}
                            >
                                Features
                            </div> */}
                        </div>
                    )}
                </div>
            </div>

            <Modal isOpen={isQRModalOpen} onClose={() => setIsQRModalOpen(false)}>
                <div className="qr-container">
                    <h2 className="qr-title">Scan to Download</h2>
                    <img
                        src={qrImage}
                        alt="QR Code"
                        className="qr-code"
                    />
                    <p className="qr-description">Scan this QR code with your mobile device to download the app</p>
                </div>
            </Modal>

            <div className="privacy-policy-container">
                <h1 className="privacy-policy-title">Privacy Policy for Civitas</h1>
                <p className="privacy-policy-update-date">Last updated: October 6, 2026</p>

                <section className="privacy-section">
                    <p className="privacy-text">
                        Civitas is built so that your game stays on your device. This page explains what the app stores and what leaves your phone. The short version: everything is stored on your device, there is no account, and the only thing sent anywhere is anonymous performance and crash reports.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">No accounts</h3>
                    <p className="privacy-text">
                        The app has no sign-up, sign-in or cloud sync. It never asks for your name, email address or Apple ID, and it does not create a profile of you anywhere.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">What is stored on your device</h3>
                    <p className="privacy-text">
                        Your saved games and your settings. All of this lives only on your device, in the app's own storage. Deleting the app deletes it. If you use iCloud device backup, it is included in that backup like any other app data, under Apple's terms.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Analytics</h3>
                    <p className="privacy-text">
                        Civitas sends anonymous performance and crash reports to Expo's EAS Observe service so we can see whether the app launches quickly and whether it crashes. A report contains timings, any error that occurred, the app version, the platform and the device type, tagged with a random identifier that is unique to this install and resets if you delete and reinstall the app. Reports contain no game saves, no free text, and nothing that identifies you. Expo processes these reports on our behalf and keeps them for at least 60 days. They are never sold, never shared with anyone else, and never used for advertising.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Children</h3>
                    <p className="privacy-text">
                        The app is not directed at children under 13 and collects no personal information from anyone.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Your choices</h3>
                    <p className="privacy-text">
                        Delete the app to remove everything it stores.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">This website</h3>
                    <p className="privacy-text">
                        taci.uk uses Google Analytics to count visits and see which pages are read. It sets cookies in your browser and records the page you view, the site that linked you here, your browser, device type and approximate location (worked out from your IP address, which Google does not store). It is used only on this website, never inside the app, and is not linked to anything you do in the app. You can block it with a content blocker or Google's opt-out add-on at tools.google.com/dlpage/gaoptout.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Changes to this policy</h3>
                    <p className="privacy-text">
                        If the app's handling of data changes, this page will change with it and the date above will be updated.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Contact</h3>
                    <p className="privacy-text">
                        Civitas is made by Michael Taciuk. Questions about privacy or the app can be sent to:
                        <br />
                        <a href="mailto:support@taci.uk" className="privacy-contact-link">support@taci.uk</a>
                    </p>
                </section>
            </div>

            <footer className="footer">
                <div className="footer-container">
                </div>
                <p className="footer-credits">Made with Love ❤️</p>
                {/* <p className="footer-credits">© 2025 Tantalum Technology Corp. All Rights Reserved.</p> */}
            </footer>
        </div>
    );
};

export default CivitasPrivacyPage;